export default {"src":"/_next/static/media/file-servers.d84547e6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};